/**
 * MgpPoS component module.
 * @module shared/widgets/MgpProbabilityOfSuccess
 */
import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import {Column, Image, Row, MgpPoSChart} from '../../shared';

const _RemovableRow = styled(Row)`
  ${props => !props.showLogo && 'visibility: hidden; height: 0px; width: 0px;'}
`;

const _Spacer = styled.div`
  height: 40px;
  visibility: hidden;
`;

/**
 * MgpPoS component
 * @name MgpPoS
 */
const MgpPoS = (props) => {
  const {action, probabilityOfSuccess, showLogo, layoutSize} = props;
  const onMgpPosClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    action(e);
  };

  return <Column width={'100%'} height={'100%'} alignItems={'left'} justifySubColumn={'space between'} overflow={'hidden'}>
    <_RemovableRow width={'fit-content'} justifySubRow={'left'} showLogo={showLogo}>
      <Image src={'https://media.circleblack.com/providers/moneyguide_logo_white.png'} maxHeight={'30px'}/>
    </_RemovableRow>
    <Row action={action && onMgpPosClick}>
      <MgpPoSChart probabilityOfSuccess={probabilityOfSuccess} layoutSize={layoutSize}/>
    </Row>
    <_RemovableRow width={'fit-content'} justifySubRow={'left'} showLogo={showLogo}>
      <_Spacer>&nbsp;</_Spacer>
    </_RemovableRow>
  </Column>;
};

export default MgpPoS;

MgpPoS.propTypes = {
  /**
   * The action to take when user clicks on ProbabilityOfSuccess Box; optional
   */
  action: PropTypes.func,
  /**
   * The ProbabilityOfSuccess Number and Text to display
   */
  probabilityOfSuccess: PropTypes.shape({
    percent: PropTypes.string,
    text: PropTypes.string,
  }),
  /**
   * Whether or not the Chart display the partner logo above the chart.
   */
  showLogo: PropTypes.bool,
  /**
   * The size of the component ('xs', 'sm', or 'md')
   */
  layoutSize: PropTypes.string,
};
